import { Box, Typography, LinearProgress } from '@mui/material';

export default function UpdatingStep({ progress, method }) {
  const determinate = method === 'ota';
  return (
    <Box sx={{ maxWidth: 440, mx: 'auto', py: 5, textAlign: 'center' }}>
      <Typography variant="h6" gutterBottom>Updating your sensor&hellip;</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {method === 'usb' ? 'Follow the popup to install. ' : ''}Please keep the USB cable connected.
      </Typography>
      <LinearProgress
        variant={determinate ? 'determinate' : 'indeterminate'}
        value={determinate ? Math.round((progress || 0) * 100) : undefined}
      />
    </Box>
  );
}
